<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered">
            <div v-if="!isSend" class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23 mb-20">계정확인</p>
                        <a class="float-right layer-close ml-30 pointer" @click="$emit('close')">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 mb-20">
                            로그인 5회 연속 실패로 차단되었습니다. <br>
                            계정 확인을 위해 신청하셨던 E-mail을 입력해 주세요!
                        </p>

                        <div>
                            <input type="text" class="md-input" v-model="email" placeholder="E-mail을 입력해 주세요.">
                            <!-- 등록 된 E-mail 이 없을 경우 -->
                            <!-- <span class="mt-10 txt-red font-13 dp-block">등록된 E-mail이 없습니다.</span> -->
                        </div>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="admin-btn-default btn ml-05 pointer" @click="sendEmail()">확인</a>
                </div>

                <!-- <h2>비밀번호 찾기</h2>
                <div v-if="!isSend">
                    비밀번호를 잊으셨나요?<br>
                    이메일과 이름을 입력해주세요.<br>
                    <input type="text" v-model="email" placeholder="이메일을 입력해주세요.">
                    <div>
                        <button type="button" @click="sendEmail()">확인</button>
                    </div>
                </div>
                <div v-else>
                    이메일로 비밀번호 재설정 링크가 발송되었습니다. <br>
                    이메일을 확인해주세요. <br>
                    <button type="button" @click="$emit('close')">닫기</button>
                </div> -->
            </div>

            <div v-else class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23 mb-20">계정잠금 해제</p>
                        <a class="float-right layer-close ml-30 pointer" @click="$emit('close')">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 mb-20 w-400px">
                            입력하신 E-mail로 계정 확인 링크가 발송되었습니다. <br>
                            E-mail을 확인해 주세요!
                        </p>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="admin-btn-default btn ml-05 pointer" @click="$emit('close')">확인</a>
                </div>
            </div>
            <!-- <footer class="modal-footer">
                <slot name="footer">
                    <button @click="$emit('close')">Close</button>
                </slot>
            </footer> -->
        </div>
    </div>
</transition>
</template>

<script>
import {
    EmptyCheck,
    EmailFormatCheck
} from '@/utils/validation.js'
export default {
    data: () => ({
        email: '',
        isSend: false // 메일 발송했는지 여부
    }),

    methods: {
        // 입력한 이메일로 비밀번호 재설정 메일 발송
        sendEmail() {
            if (!EmptyCheck(this.email, '이메일을')) {
                return false
            }

            if (!EmailFormatCheck(this.email)) {
                return false
            }

            var pageIdx = sessionStorage.getItem('pageIdx')
            var params = {
                code: 'lock_email',
                id: this.email,
                pageIdx: pageIdx
            }

            this.axios.get(this.axios.root + this.axios.port + `/user/lock-email/${pageIdx}`, {
                    params: params
                })
                .then(res => {
                    this.isSend = true
                    // console.log('res', res)
                    sessionStorage.setItem('fixPWEmail', this.email)
                    localStorage.setItem('authEmail', this.email)
                    alert('입력하신 E-mail로 비밀번호 재설정 링크가 발송되었습니다.\nE-mail을 확인해 주세요!')
                }).catch(err => {
                    alert('수강신청 내역이 없는 E-mail입니다.')
                    // console.log(err)
                    // alert(err)
                })

        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
